<div class="ct">
  @if (showSearch) {
    <label class="ct__search">
      <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
      <input type="search" [value]="search"
        (input)="onSearch($any($event.target).value)"
        [placeholder]="'FORMS.SEARCH' | translate"
        [attr.aria-label]="'FORMS.SEARCH' | translate" autocomplete="off">
      @if (search) {
        <button type="button" class="ct__search-clear" (click)="onSearch('')"
          [attr.aria-label]="'BUTTONS.CANCEL' | translate">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      }
    </label>
  }

  <app-data-table
    [columns]="dtColumns"
    [rows]="pagedRows"
    [rowTemplate]="rowTpl"
    [sortBy]="sortBy"
    [sortDescending]="sortDescending"
    [page]="page"
    [pageSize]="pageSize"
    [pageSizes]="pageSizeOptions"
    [showPager]="true"
    emptyIcon="table-cells"
    [emptyTitleKey]="emptyBecauseFiltered ? 'FILTERS.EMPTY_TITLE' : 'DATA_TABLE.EMPTY_TITLE'"
    [emptyMessageKey]="emptyBecauseFiltered ? 'FILTERS.EMPTY_MESSAGE' : 'DATA_TABLE.EMPTY_MESSAGE'"
    (sortChange)="onSort($event)"
    (pageChange)="onPage($event)"
    (pageSizeChange)="onPageSize($event)">
  </app-data-table>
</div>

<!-- Gabarit de ligne : par colonne → template d'actions, gabarit de cellule
     fourni, ou texte résolu depuis le champ. -->
<ng-template #rowTpl let-item>
  @for (col of columns; track columnKey(col) || $index) {
    @if (isActionColumn(col)) {
      <td class="ct__actions-cell">
        @if (actionTemplate) {
          <ng-container [ngTemplateOutlet]="actionTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
        }
      </td>
    } @else if (cellTemplateFor(col)) {
      <td class="ct__cell"
          [class.ct-hide-md]="col.hideBelow === 'md'"
          [class.ct-hide-lg]="col.hideBelow === 'lg'">
        <ng-container [ngTemplateOutlet]="cellTemplateFor(col)!"
          [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      </td>
    } @else {
      <td class="ct__cell"
          [class.ct-hide-md]="col.hideBelow === 'md'"
          [class.ct-hide-lg]="col.hideBelow === 'lg'"
          (click)="rowClick.emit(item)">{{ cellValue(item, col) }}</td>
    }
  }
</ng-template>
